import * as React from 'react';
import WaitingRoom from 'containers/WaitingRoom';
import { initSession, userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';
import { IntegrationType, integrationType } from 'utils/ui/app';

export interface IDealerEntryProps {
  children?: React.ReactNode;
  className?: string;
  // skip the waiting room and go directly to the stream
  skipWaitingRoom?: boolean;
}

export const DealerEntry: React.FC<IDealerEntryProps> = ({ children, className, skipWaitingRoom }) => {
  const [ready, setReady] = React.useState(false);
  const session = userSession().useState();
  tenantConfig().useState();

  React.useLayoutEffect(() => {
    (async () => {
      const isWebComponent = integrationType() === IntegrationType.WebComponent;
      if (isWebComponent && session.id) {
        // standalone uses routing for this, but web component does not use the router
        await initSession(session.id);
      }
    })();
  }, [session.id]);

  const displayWaitingRoom = !skipWaitingRoom && userSession().dealerWaitingRoomEligible;

  // Block body scroll while the waiting room overlay is visible, so the fixed overlay
  // cannot be scrolled past to reveal stream content underneath (AVS-4303).
  // Children are always rendered so EmbeddedStream stays mounted and preserves its
  // isSessionHost state across the waiting room lifecycle (AVS-4307).
  React.useEffect(() => {
    if (displayWaitingRoom) {
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previousOverflow;
      };
    }
  }, [displayWaitingRoom]);

  return (
    <>
      {displayWaitingRoom && <WaitingRoom className={className} ready={ready} setReady={setReady} />}
      {children}
    </>
  );
};

export default DealerEntry;
